import { Stack } from "expo-router";
import { RequireCameraKey } from "@src/components/web/RequireCameraKey.web";
import { WebLayout } from "@src/components/web/WebLayout.web";
import { SceneCompareContent } from "@src/components/web/SceneCompare.web";

export default function SceneCompareScreen() {
  return (
    <RequireCameraKey requireSiteId>
      {({ cameraKey, siteId }) => (
        <>
          <Stack.Screen options={{ headerShown: false }} />
          <WebLayout>
            <SceneCompareContent cameraKey={cameraKey} siteId={siteId} />
          </WebLayout>
        </>
      )}
    </RequireCameraKey>
  );
}
